import React, {Component, ReactElement, ReactNode} from 'react'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    MESSAGE_TYPE,
    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY,
    ROLE_FOR_ADMINISTRATOR,
    ROLE_FOR_RESIDENT,
    SELECT_USER_TYPE,
} from '../../../CodeMaster'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {valueOrNoSelected} from '../../../componentHelper/selectHelper'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import styled from 'styled-components'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import {Messages} from '../../../Messages'
import {
    NatPostResidentUserRegistrationApplyRequest,
    NatPostResidentUserRegistrationApplyResponse,
} from '../roomToResident/repository/NatPostResidentUserRegistrationApply'
import {formatForDateInput} from '../../../formatters/formatDate'
import {StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import NatRegistrationApplyMemoForm from './admin/NatRegistrationApplyMemoForm'
import {NatAdminCommonDialogComponent} from '../common/admin/NatAdminCommonDialogComponent'
import {autoKanaOnUpdate, getStringOrEmptyString} from '../../common/util/Natutil'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {NatGetRidge, RidgeData} from '../ridge/repository/NatGetRidge'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {
    NatPutRoomToResidentNoticeApply,
    NatPutRoomToResidentNoticeApplyParams,
} from '../roomToResident/repository/NatPutRoomToResidentNoticeApply'
import {NatGetRoomToResidentDetails} from '../roomToResident/repository/NatGetRoomToResidentDetails'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    roomToResidentRepo: NatRoomToResidentRepo
    ridgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    applyCategory: Nullable<RESIDENT_USER_REGISTRATION_APPLY_CATEGORY>
    abolitionApplyFormFamilyName: string
    abolitionApplyFormFirstName: string
    abolitionExpectedDate: string
    registrationRoleId: ROLE_FOR_RESIDENT
    registrationStartDate: string
    registrationFamilyName: string
    registrationFirstName: string
    registrationFamilyNameKana: string
    registrationFirstNameKana: string
    sutekiNetId: string
    ridgeInfo: RidgeData[]
    ridgeCd: string
    ridgeName: string
    roomNumber: string
    roomToResidentSeq: Nullable<number>
    familyName: string
    firstName: string
    adminFamilyName: string
    adminFirstName: string
    memo: string
    dialogOpenSelectResidentUser: boolean
    noticeApplyOpen: boolean
    clearErrorMessage: boolean
    allResidentStatus: boolean
    invalidUserSelectFlag: boolean
    unregisteredResidentStatus: boolean
    sameRoomDuplicateExclusionFlag: boolean
    isLoadCompleted: boolean
    applicantName: string
    roomToResidentCondominiumCd: string
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

class NatAdminResidentUserApplyPage extends Component<Props & AdminPagePropsSet, States> {

    selectedCondominiumCd: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.selectedCondominiumCd = NatAdminLoginInfoSessionStorageHelper.getStringItemOrNull(
            AdminLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD)

        this.state = {
            applyCategory: null,
            abolitionApplyFormFamilyName: '',
            abolitionApplyFormFirstName: '',
            abolitionExpectedDate: '',
            registrationRoleId: ROLE_FOR_RESIDENT.RESIDENT,
            registrationStartDate: '',
            registrationFamilyName: '',
            registrationFirstName: '',
            registrationFamilyNameKana: '',
            registrationFirstNameKana: '',
            sutekiNetId: '',
            ridgeInfo: [],
            ridgeCd: '',
            ridgeName: '',
            roomNumber: '',
            roomToResidentSeq: null,
            familyName: '',
            firstName: '',
            adminFamilyName: '',
            adminFirstName: '',
            memo: '',
            dialogOpenSelectResidentUser: false,
            noticeApplyOpen: false,
            clearErrorMessage: false,
            allResidentStatus: false,
            invalidUserSelectFlag: false,
            unregisteredResidentStatus: false,
            sameRoomDuplicateExclusionFlag: false,
            isLoadCompleted: false,
            applicantName: '',
            roomToResidentCondominiumCd: '',
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.handleApplyCategoryChange = this.handleApplyCategoryChange.bind(this)
        this.handleRegistrationRidgeChange = this.handleRegistrationRidgeChange.bind(this)
        this.handleRegistrationRoomNumberChange = this.handleRegistrationRoomNumberChange.bind(this)
        this.handleAbolitionApplyFormFamilyNameChange = this.handleAbolitionApplyFormFamilyNameChange.bind(this)
        this.handleAbolitionApplyFormFirstNameChange = this.handleAbolitionApplyFormFirstNameChange.bind(this)
        this.handleAbolitionExpectedDateChange = this.handleAbolitionExpectedDateChange.bind(this)
        this.handleRegistrationRoleIdChange = this.handleRegistrationRoleIdChange.bind(this)
        this.handleRegistrationStartDateChange = this.handleRegistrationStartDateChange.bind(this)
        this.handleRegistrationFamilyNameChange = this.handleRegistrationFamilyNameChange.bind(this)
        this.handleRegistrationFirstNameChange = this.handleRegistrationFirstNameChange.bind(this)
        this.handleRegistrationFamilyNameKanaChange = this.handleRegistrationFamilyNameKanaChange.bind(this)
        this.handleRegistrationFirstNameKanaChange = this.handleRegistrationFirstNameKanaChange.bind(this)
        this.handleNoticeApplyCancelClick = this.handleNoticeApplyCancelClick.bind(this)
        this.handleNoticeApplyOkClick = this.handleNoticeApplyOkClick.bind(this)
        this.handleMemoChange = this.handleMemoChange.bind(this)
        this.judgeRegisterButtonDisabled = this.judgeRegisterButtonDisabled.bind(this)
        this.noticeApplyClick = this.noticeApplyClick.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.handleApplicantNameChange = this.handleApplicantNameChange.bind(this)
        this.handleRegisterResidentUserApplyOkClick = this.handleRegisterResidentUserApplyOkClick.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const ridge: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
                this.props.ridgeRepo.getRidgeList.bind(this.props.ridgeRepo, this.selectedCondominiumCd ?
                    this.selectedCondominiumCd : undefined),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (ridge && ridge.details) {
                this.setState({ridgeInfo: ridge.details})
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    clearInputValue(): void {
        this.beforeUserAction()
        this.setState({
            abolitionApplyFormFamilyName: '',
            abolitionApplyFormFirstName: '',
            abolitionExpectedDate: '',
            registrationRoleId: ROLE_FOR_RESIDENT.RESIDENT,
            registrationStartDate: '',
            registrationFamilyName: '',
            registrationFirstName: '',
            registrationFamilyNameKana: '',
            registrationFirstNameKana: '',
            sutekiNetId: '',
            ridgeCd: '',
            ridgeName: '',
            roomNumber: '',
            roomToResidentSeq: null,
            familyName: '',
            firstName: '',
            adminFamilyName: '',
            adminFirstName: '',
            memo: '',
            clearErrorMessage: true,
            applicantName: '',
            roomToResidentCondominiumCd: '',
        })
    }

    handleNoticeApplyCancelClick(): void {
        this.setState({noticeApplyOpen: false})
    }

    async handleRegisterResidentUserApplyOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            // 居住者ユーザ登録申請登録
            const registerResidentUserRegistrationApplyParams: NatPostResidentUserRegistrationApplyRequest = {
                applyCategory: this.state.applyCategory ? this.state.applyCategory.value : '',
                roomNumber: this.state.roomNumber,
                ridgeCd: this.state.ridgeCd,
                abolitionSeq: this.state.roomToResidentSeq,
                abolitionApplyFormFamilyName: this.state.abolitionApplyFormFamilyName,
                abolitionApplyFormFirstName: this.state.abolitionApplyFormFirstName,
                abolitionExpectedDate: this.state.abolitionExpectedDate,
                registrationRoleId: this.state.registrationRoleId.value,
                registrationFamilyName: this.state.registrationFamilyName,
                registrationFirstName: this.state.registrationFirstName,
                registrationFamilyNameKana: this.state.registrationFamilyNameKana,
                registrationFirstNameKana: this.state.registrationFirstNameKana,
                registrationStartDate: this.state.registrationStartDate,
                memo: this.state.memo,
            }

            const postResidentUserRegistrationApplyResult: Nullable<NatPostResidentUserRegistrationApplyResponse> =
                await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.postResidentUserRegistrationApply.bind(
                        this.props.roomToResidentRepo, registerResidentUserRegistrationApplyParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('居住者ユーザ申請')},
                )
            if (postResidentUserRegistrationApplyResult &&
                postResidentUserRegistrationApplyResult.details &&
                postResidentUserRegistrationApplyResult.requestError === null) {
                this.props.navigate(`/admin/residentUser/apply/${postResidentUserRegistrationApplyResult.details.applyId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0007.toString('居住者ユーザ申請'),
                            },
                        },
                    },
                )
            }

        } finally {
            this.setState({noticeApplyOpen: false})
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleNoticeApplyOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const seq = String(this.state.roomToResidentSeq)
            let version: number = 0
            // 部屋居住者取得
            const roomToResidentDetails: Nullable<NatGetRoomToResidentDetails> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getRoomToResidentDetails.bind(this.props.roomToResidentRepo,
                    this.state.roomToResidentCondominiumCd, this.state.ridgeCd, this.state.roomNumber, seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (roomToResidentDetails && roomToResidentDetails.details) {
                version = roomToResidentDetails.details.roomToResidentVersion
            }

            // 通知状発行（再発行）申請登録
            const registerRoomToResidentNoticeApplyParams: NatPutRoomToResidentNoticeApplyParams = {
                condominiumCd: this.state.roomToResidentCondominiumCd,
                ridgeCd: this.state.ridgeCd,
                roomNumber: this.state.roomNumber,
                seq: this.state.roomToResidentSeq != null ? this.state.roomToResidentSeq : 0,
                userName: this.state.applicantName,
                roomToResidentVersion: version,
            }

            const PutRoomToResidentNoticeApplyResult: Nullable<NatPutRoomToResidentNoticeApply> =
                await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putRoomToResidentNoticeApply.bind(
                        this.props.roomToResidentRepo, registerRoomToResidentNoticeApplyParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('居住者ユーザ申請')},
                )
            if (PutRoomToResidentNoticeApplyResult &&
                PutRoomToResidentNoticeApplyResult.details &&
                PutRoomToResidentNoticeApplyResult.requestError === null) {
                this.props.navigate(`/admin/residentUser/noticeApply/${PutRoomToResidentNoticeApplyResult.details.seq}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0007.toString('居住者ユーザ申請'),
                            },
                        },
                    },
                )
            }

        } finally {
            this.setState({noticeApplyOpen: false})
            this.props.eventEmitter.closeLoading()
        }
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({dialogOpenSelectResidentUser: true})
    }


    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    judgeRegisterButtonDisabled(): boolean {
        if (!(this.state.roomNumber && this.state.ridgeCd)) {
            return true
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION) {
            return !(this.state.roomToResidentSeq &&
                this.state.abolitionApplyFormFamilyName &&
                this.state.abolitionApplyFormFirstName &&
                this.state.abolitionExpectedDate)
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION) {
            return !(this.state.registrationRoleId &&
                this.state.registrationStartDate)
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) {
            return !(this.state.roomToResidentSeq &&
                this.state.abolitionApplyFormFamilyName &&
                this.state.abolitionApplyFormFirstName &&
                this.state.abolitionExpectedDate &&
                this.state.registrationRoleId &&
                this.state.registrationStartDate)
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE) {
            return !(this.state.roomToResidentSeq &&
                this.state.roomToResidentCondominiumCd &&
                this.state.applicantName)
        } else {
            return true
        }
    }


    handleApplyCategoryChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY =
            RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.codeToEnumConstants(`${event.target.value}`)
        this.setState({applyCategory})
        this.setResidentUserParameter(applyCategory)
        this.clearInputValue()
    }

    handleRegistrationRoleIdChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const registrationRoleId: ROLE_FOR_RESIDENT =
            ROLE_FOR_RESIDENT.codeToEnumConstants(`${event.target.value}`)
        this.setState({registrationRoleId})
    }

    handleRegistrationRidgeChange(event: SelectChangeEvent<unknown>): void {
        this.setState({ridgeCd: event.target.value as string})
    }

    handleRegistrationRoomNumberChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roomNumber: event.target.value})
    }

    handleAbolitionApplyFormFamilyNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({abolitionApplyFormFamilyName: value})
    }

    handleAbolitionApplyFormFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({abolitionApplyFormFirstName: value})
    }


    handleAbolitionExpectedDateChange(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({abolitionExpectedDate: formatForDateInput(date.toString())})
        } else {
            this.setState({abolitionExpectedDate: ''})
        }
    }

    handleRegistrationStartDateChange(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({registrationStartDate: formatForDateInput(date.toString())})
        } else {
            this.setState({registrationStartDate: ''})
        }
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.registrationFamilyNameKana ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.registrationFirstNameKana ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    handleRegistrationFamilyNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFamilyName: value,
            registrationFamilyNameKana: value ? this.state.convertFamilyNameKana : '',
        })
    }

    handleRegistrationFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFirstName: value,
            registrationFirstNameKana: value ? this.state.convertFirstNameKana : '',
        })
    }

    handleRegistrationFamilyNameKanaChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({registrationFamilyNameKana: value})
    }

    handleRegistrationFirstNameKanaChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({registrationFirstNameKana: value})
    }

    handleMemoChange(value: string): void {
        this.setState({memo: value})
    }

    handleApplicantNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({applicantName: event.target.value})
    }

    convertRidgeIntoOptionProps(): OptionProps[] {
        const optionProps: OptionProps[] = this.state.ridgeInfo.map((ridge) => {
            return ({
                label: `${ridge.ridgeCd} : ${ridge.ridgeName}`,
                value: `${ridge.ridgeCd}`,
            })
        })
        return [{
            label: '棟を指定してください',
            value: '',
        }, ...optionProps]
    }

    setResidentUserParameter(applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY): void {
        switch (applyCategory) {
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION:
                this.setState({
                    allResidentStatus: false,
                    invalidUserSelectFlag: true,
                    unregisteredResidentStatus: false,
                    sameRoomDuplicateExclusionFlag: false,
                })
                break
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION:
                this.setState({
                    allResidentStatus: true,
                    invalidUserSelectFlag: false,
                    unregisteredResidentStatus: false,
                    sameRoomDuplicateExclusionFlag: true,
                })
                break
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION:
                this.setState({
                    allResidentStatus: false,
                    invalidUserSelectFlag: true,
                    unregisteredResidentStatus: false,
                    sameRoomDuplicateExclusionFlag: false,
                })
                break
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE:
                this.setState({
                    allResidentStatus: false,
                    invalidUserSelectFlag: false,
                    unregisteredResidentStatus: true,
                    sameRoomDuplicateExclusionFlag: false,
                })
                break
        }
    }

    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <colgroup>
                        <col width={'25%'}/>
                        <col width={'20%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                        <col width={'30%'}/>
                    </colgroup>
                    <StyledTableCaption>申請情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>申請区分</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.values()}
                                    onChange={this.handleApplyCategoryChange}
                                    value={valueOrNoSelected(this.state.applyCategory)}
                                    eventKeys={['applyCategory']}
                                    eventEmitter={this.props.eventEmitter}
                                    clearError={this.state.clearErrorMessage}
                                />
                            </TableCell>
                        </TableRow>
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE) &&
                            <TableRow>
                                <TableRowName required>居住者ユーザを選択</TableRowName>
                                <TableCell colSpan={4}>
                                    <RowFlexContainer>
                                        <SelectedFlexWrapper>
                                            <PPErrorDisplayButton
                                                component={'span'}
                                                size={'small'}
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['sutekiNetId', 'ridgeCd', 'roomNumber', 'abolitionSeq', 'seq']}
                                                onClick={this.handleOpenResidentUserSelectionDialog}
                                                clearError={this.state.clearErrorMessage}
                                            >
                                                選択する
                                            </PPErrorDisplayButton>
                                        </SelectedFlexWrapper>
                                        {this.renderSelectedResidentUserInfo()}
                                    </RowFlexContainer>
                                </TableCell>
                            </TableRow>
                        }
                        {this.state.dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={this.props.roomToResidentRepo}
                                ridgeRepo={this.props.ridgeRepo}
                                selectUserType={SELECT_USER_TYPE.USER.value}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                                selectedCondominiumCd={this.selectedCondominiumCd ? this.selectedCondominiumCd : undefined}
                                allResidentStatus={this.state.allResidentStatus}
                                invalidUserSelectFlag={this.state.invalidUserSelectFlag}
                                unregisteredResidentStatus={this.state.unregisteredResidentStatus}
                                sameRoomDuplicateExclusionFlag={this.state.sameRoomDuplicateExclusionFlag}
                                mainUserFlag={true}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) &&
                            <>
                                <TableRow>
                                    <TableRowName required>廃止申請書 氏名</TableRowName>
                                    <TableCell colSpan={2}>
                                        姓
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    name: 'abolitionApplyFormFamilyName',
                                                    id: 'abolitionApplyFormFamilyName',
                                                    maxLength: 10,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            value={this.state.abolitionApplyFormFamilyName}
                                            onInput={this.handleAbolitionApplyFormFamilyNameChange}
                                            onChange={this.handleAbolitionApplyFormFamilyNameChange}
                                            eventKeys={['abolitionApplyFormFamilyName']}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorMessage}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                        名
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    name: 'abolitionApplyFormFirstName',
                                                    id: 'abolitionApplyFormFirstName',
                                                    maxLength: 10,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            value={this.state.abolitionApplyFormFirstName}
                                            onInput={this.handleAbolitionApplyFormFirstNameChange}
                                            onChange={this.handleAbolitionApplyFormFirstNameChange}
                                            eventKeys={['abolitionApplyFormFirstName']}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorMessage}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableRowName required>廃止予定日</TableRowName>
                                    <TableCell colSpan={2}>
                                        <PPDatePicker
                                            value={(this.state.abolitionExpectedDate !== '') ?
                                                new Date(this.state.abolitionExpectedDate) : null
                                            }
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['abolitionExpectedDate']}
                                            onChangeDate={this.handleAbolitionExpectedDateChange}
                                            clearError={this.state.clearErrorMessage}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                </TableRow>
                            </>
                        }
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) &&
                            <>
                                <TableRow>
                                    <TableRowName required>新規登録居住者ユーザ 権限</TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPRadioGroup
                                            row
                                            data={ROLE_FOR_RESIDENT.values()}
                                            onChange={this.handleRegistrationRoleIdChange}
                                            value={this.state.registrationRoleId.value}
                                            eventKeys={['registrationRoleId']}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorMessage}
                                        />
                                    </TableCell>
                                </TableRow>
                                {this.state.applyCategory ===
                                    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION &&
                                    <>
                                        <TableRow>
                                            <TableRowName required>新規登録居住者ユーザ 棟名</TableRowName>
                                            <TableCell colSpan={2}>
                                                <PPSelect
                                                    required
                                                    fullWidth
                                                    data={this.convertRidgeIntoOptionProps()}
                                                    onChange={this.handleRegistrationRidgeChange}
                                                    value={this.state.ridgeCd}
                                                    eventKeys={['ridgeCd']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    clearError={this.state.clearErrorMessage}

                                                />
                                            </TableCell>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableRowName required>新規登録居住者ユーザ 部屋番号</TableRowName>
                                            <TableCell colSpan={2}>
                                                <PPTextField
                                                    InputProps={{
                                                        inputProps: {
                                                            maxLength: 4,
                                                        },
                                                    }}
                                                    required
                                                    fullWidth
                                                    onChange={this.handleRegistrationRoomNumberChange}
                                                    value={this.state.roomNumber}
                                                    eventKeys={['roomNumber']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    clearError={this.state.clearErrorMessage}
                                                />
                                            </TableCell>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>
                                    </>
                                }
                            <TableRow>
                                <TableRowName>新規登録居住者ユーザ 氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    姓
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFamilyName',
                                                id: 'registrationFamilyName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFamilyName}
                                        onInput={this.handleRegistrationFamilyNameChange}
                                        onChange={this.handleRegistrationFamilyNameChange}
                                        onCompositionStart={this.onCompositionStartFamilyName}
                                        onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                        eventKeys={['registrationFamilyName']}
                                        eventEmitter={this.props.eventEmitter}
                                        clearError={this.state.clearErrorMessage}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    名
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFirstName',
                                                id: 'registrationFirstName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFirstName}
                                        onInput={this.handleRegistrationFirstNameChange}
                                        onChange={this.handleRegistrationFirstNameChange}
                                        onCompositionStart={this.onCompositionStartFirstName}
                                        onCompositionUpdate={this.onCompositionUpdateFirstName}
                                        eventKeys={['registrationFirstName']}
                                        eventEmitter={this.props.eventEmitter}
                                        clearError={this.state.clearErrorMessage}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>新規登録居住者ユーザ 氏名(フリガナ)</TableRowName>
                                <TableCell colSpan={2}>
                                    セイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFamilyNameKana',
                                                id: 'registrationFamilyNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFamilyNameKana}
                                        onInput={this.handleRegistrationFamilyNameKanaChange}
                                        onChange={this.handleRegistrationFamilyNameKanaChange}
                                        eventKeys={['registrationFamilyNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                        clearError={this.state.clearErrorMessage}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    メイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFirstNameKana',
                                                id: 'registrationFirstNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFirstNameKana}
                                        onInput={this.handleRegistrationFirstNameKanaChange}
                                        onChange={this.handleRegistrationFirstNameKanaChange}
                                        eventKeys={['registrationFirstNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                        clearError={this.state.clearErrorMessage}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>利用開始日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                    <PPDatePicker
                                        value={(this.state.registrationStartDate !== '') ?
                                            new Date(this.state.registrationStartDate) : null
                                        }
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['registrationStartDate']}
                                        onChangeDate={this.handleRegistrationStartDateChange}
                                        clearError={this.state.clearErrorMessage}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}></TableCell>
                            </TableRow>
                        </>
                    }
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE) &&
                            <>
                                <TableRow>
                                    <TableRowName required>申請者氏名</TableRowName>
                                    <TableCell colSpan={1}>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 21,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            value={this.state.applicantName}
                                            onChange={this.handleApplicantNameChange}
                                            eventKeys={['userName']}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearErrorMessage}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={3}></TableCell>
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): void {
        this.setState({
            sutekiNetId: selectedResidentUserInfo.sutekiNetId,
            ridgeCd: selectedResidentUserInfo.ridgeCd,
            ridgeName: selectedResidentUserInfo.ridgeName,
            roomNumber: selectedResidentUserInfo.roomNumber,
            roomToResidentSeq: selectedResidentUserInfo.seq,
            roomToResidentCondominiumCd: selectedResidentUserInfo.condominiumCd,
            familyName: selectedResidentUserInfo.familyName ? selectedResidentUserInfo.familyName : '',
            firstName: selectedResidentUserInfo.firstName ? selectedResidentUserInfo.firstName : '',
            adminFamilyName: selectedResidentUserInfo.adminFamilyName ? selectedResidentUserInfo.adminFamilyName : '',
            adminFirstName: selectedResidentUserInfo.adminFirstName ? selectedResidentUserInfo.adminFirstName : '',
            dialogOpenSelectResidentUser: false,
        })
    }


    renderSelectedResidentUserInfo(): ReactNode {
        if (!this.state.sutekiNetId) {
            return (<></>)
        }
        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>
                        {this.state.ridgeName} {this.state.roomNumber}
                    </SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueForUserName>
                        {this.getDisplayName(this.state.familyName, this.state.firstName)}
                    </SelectedModalInfoItemValueForUserName>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueForUserName>
                        {this.getDisplayName(this.state.adminFamilyName, this.state.adminFirstName)}
                    </SelectedModalInfoItemValueForUserName>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    getDisplayName(familyName: Nullable<string>, firstName: Nullable<string>): string {
        if (familyName || firstName) {
            return (`${getStringOrEmptyString(familyName)} ${getStringOrEmptyString(firstName)}`)
        } else {
            return ''
        }
    }

    // 登録ボタン押下
    async noticeApplyClick(): Promise<void> {
        this.setState({
            noticeApplyOpen: true,
            clearErrorMessage: false,
        })
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeRegisterButtonDisabled()}
                        onClick={this.noticeApplyClick}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={'/admin/residentUser/applyList'}
                    >
                        居住者ユーザ申請一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const memoForm = (<NatRegistrationApplyMemoForm
            memo={this.state.memo}
            eventEmitter={this.props.eventEmitter}
            onChange={this.handleMemoChange}
        />)

        return (
            <>
                {this.state.applyCategory ===
                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.NOTICE_REISSUE ?
                    <NatAdminCommonDialogComponent
                        params={{
                            title: '確認',
                            errorLevel: Messages.IRESA0014.errorLevel,
                            message: Messages.IRESA0014.toString(ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.label),
                            buttonProps: [
                                {
                                    isDefault: false,
                                    buttonLabel: 'キャンセル',
                                    buttonHandler: this.handleNoticeApplyCancelClick,
                                    buttonDisabled: false,
                                },
                                {
                                    isDefault: false,
                                    buttonLabel: 'OK',
                                    buttonHandler: this.handleNoticeApplyOkClick,
                                    buttonDisabled: false,
                                },
                            ],
                        }}
                        inputAreaComponent={null}
                        open={this.state.noticeApplyOpen}/> :
                    <NatAdminCommonDialogComponent
                        params={{
                            title: '確認',
                            errorLevel: Messages.IRESA0027.errorLevel,
                            message: Messages.IRESA0027.toString(),
                            buttonProps: [
                                {
                                    isDefault: false,
                                    buttonLabel: 'キャンセル',
                                    buttonHandler: this.handleNoticeApplyCancelClick,
                                    buttonDisabled: false,
                                },
                                {
                                    isDefault: false,
                                    buttonLabel: 'OK',
                                    buttonHandler: this.handleRegisterResidentUserApplyOkClick,
                                    buttonDisabled: false,
                                },
                            ],
                        }}
                        inputAreaComponent={memoForm}
                        open={this.state.noticeApplyOpen}/>
                }
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )

    }
}

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

export const SelectedModalInfoItemLabel: StyledSpan = styled.span`
  font-size: smaller;
  white-space: nowrap;
  margin-left: 20px;
  margin-right: 20px;
`

export const SelectedModalInfoItemValue: StyledSpan = styled.span`
  font-weight: bolder;
  white-space: normal;
  margin-right: 20px;
`

export const SelectedModalInfoItemValueForUserName = styled(SelectedModalInfoItemValue)`
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
`

export default createAdminPage(NatAdminResidentUserApplyPage)
